import { render, staticRenderFns } from "./ProjectConflictsPage.vue?vue&type=template&id=00c45914&"
import script from "./ProjectConflictsPage.vue?vue&type=script&lang=js&"
export * from "./ProjectConflictsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports